<template>
	<b-modal id="upload-pod-modal" title="Carica curve" :no-close-on-backdrop="true" hide-footer>
		<b-form @submit="onSubmit" ref="form" novalidate class="needs-validation">
			<b-form-group label="Sito">
				<b-form-select required v-model="siteId" :options="sites" />
			</b-form-group>
			<b-form-group label="Canale">
				<b-form-select required :disabled="!siteId" v-model="channelCode" :options="channels" />
			</b-form-group>			
			<b-row>
				<b-col>
					<b-form-group label="Fornitore">
						<b-form-select required v-model="supplier" :options="suppliers" />
					</b-form-group>
				</b-col>
				<b-col>
					<b-form-group label="POD">
						<b-form-input required v-model="pod" />
					</b-form-group>
				</b-col>

			</b-row>
			<b-form-group>
				<b-row>
					<b-col>
						<span class="d-block">Dal</span>
						<vue-monthly-picker v-model="fromMonth" :monthLabels="monthLabels" :dateFormat="'MMMM YYYY'"
							:clearOption="false" :class="{ err: errorFrom }" />
					</b-col>
					<b-col>
						<span class="d-block">Al</span>
						<vue-monthly-picker v-model="toMonth" :monthLabels="monthLabels" :dateFormat="'MMMM YYYY'"
							:class="{ err: errorTo }" :clearOption="false" />
					</b-col>
				</b-row>
			</b-form-group>
			<b-row>
				<b-col class="d-flex justify-content-end">
					<b-btn class="mr-2" variant="secondary" @click="$bvModal.hide('upload-pod-modal')">Annulla</b-btn>
					<b-btn type="submit" variant="primary">Carica curve</b-btn>
				</b-col>
			</b-row>
		</b-form>
	</b-modal>
</template>
<script>
import { mapGetters } from 'vuex'
import VueMonthlyPicker from 'vue-monthly-picker'
import moment from 'moment'

export default {
	name: "UploadPodModal",
	components: { VueMonthlyPicker },
	data() {
		return {
			id: null,
			siteId: null,
			channelCode: null,
			supplier: null,
			pod: null,
			fromMonth: null,
			toMonth: null,
			errorFrom: false,
			errorTo: false,
			suppliers: [
				{ value: 'IT001E - E-DISTRIBUZIONE SPA', text: 'E-DISTRIBUZIONE SPA' },
			]
		}
	},
	created() {
		if (this.userSites.length == 1) {
			this.siteId = this.userSites[0].id
		}
	},
	methods: {
		setData(report) {
			Object.keys(report).forEach(key => {
				this[key] = report[key]
			})
			this.fromMonth = moment(`${report.from}01`, 'YYYYMMDD')
			this.toMonth = moment(`${report.to}01`, 'YYYYMMDD')
		},
		async onSubmit(e) {
			e.preventDefault()
			this.errorFrom = !this.fromMonth
			this.errorTo = !this.toMonth
			if (!this.$refs.form.checkValidity()) {
				this.$refs.form.classList.add('was-validated');
				return;
			}
			if (this.errorFrom || this.errorTo) {
				return;
			}

			const data = {
				supplier: this.supplier,
				pod: this.pod,				
				from: this.fromMonth.format('YYYY-MM-DD'), 
				to: this.fromMonth.format('YYYY-MM-DD'), 
				channelCode: this.channelCode
			}

			this.$store.commit("loading")
			this.$bvModal.hide('report-modal')

			const result = await this.$store.dispatch(`billaudit/uploadPod`, data)
			this.$store.commit("stopLoading");

			if (result.code < 0) {
				this.$notify({
					type: "error",
					text: result.message,
					title: 'Errore',
				});
			} else {

				const active = result.data[0] > 0
				const reactive = result.data[1] > 0

				const messages = [ ]
				if (active) { 
					messages.push('Curva attiva caricata correttamente, log Enerp: ' + result.data[0])
				} else {
					messages.push('Curva attiva caricata con errore, verificare log Enerp')
				}
				if (reactive) {
					messages.push('Curva reattiva caricata correttamente, log Enerp: ' + result.data[0])
				} else {
					messages.push('Curva reattiva caricata con errore, verificare log Enerp')
				}

				this.$notify({
					type: "success",
					text: messages.join('\n<br />'),
					title: 'Conferma',
				});
				this.$emit("completed")
			}
		}
	},
	computed: {
		...mapGetters(['userSites']),
		monthLabels() {
			return this.$store.state.utils.monthsShort;
		},
		sites() {
			return this.userSites.map(site => {
				return {
					value: site.id,
					text: site.name
				}
			})
		},
		channels() {
			if (!this.siteId) {
				return []
			}
			return this.userSites
				.find(site => site.id == this.siteId)
				.channels
				.filter(channel => channel.is_supply == 1)
				.map(channel => {
					return {
						value: channel.code,
						text: channel.name
					}
				})
		},
	}
}
</script>
<style>
.err .month-year-display.input {
	border-color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/BillAudit/Modals/UploadPodModal.vue